module.exports = __webpack_public_path__ + "static/media/mail.83e53d8e.svg";